import moment from "moment";
import Vue from "vue";

import eventAction from "@/store/eventAction";

import cache from "@/store/cache.js";
import utils from "@/utils";
const vue = new Vue();

function defaultState() {
  return {
    all: [],
    loaded: false,
    last: null
  };
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  socket_events({ commit, state }, data) {
    if (data.events) {
      commit(
        "ADD_RANGE",
        data.events.map(e => {
          return {
            card: cache.cards.byId(e.card_id),
            event: e
          };
        })
      );
    }

    state.loaded = true;
  },
  async socket_newEvents({ dispatch }, data) {
    if (data.events) {
      data.events.sort((a, b) => a.id - b.id);
      for (let i = 0; i < data.events.length; i++) {
        await dispatch("socket_event", data.events[i]);
      }
    }
  },
  async socket_event({ commit, dispatch }, event) {
    let moduleName = null;
    if (eventAction.forBoards(event)) {
      moduleName = "boards";
    } else if (eventAction.forLists(event)) {
      moduleName = "lists";
    } else if (eventAction.forCards(event)) {
      moduleName = "cards";
    } else if (eventAction.forCardMessages(event)) {
      moduleName = "cardMessages";
    } else if (eventAction.forFieldsTxt(event)) {
      moduleName = "fieldsTxt";
    } else if (eventAction.forFieldsInt(event)) {
      moduleName = "fieldsInt";
    } else if (eventAction.forTheme(event)) {
      moduleName = "theme";
    } else if (eventAction.forFiles(event)) {
      moduleName = "files";
    } else if (eventAction.forAlarms(event)) {
      moduleName = "alarms";
    } else if (eventAction.forBotRiotLists(event)) {
      moduleName = "botRiotLists";
    }

    if (!moduleName) {
      console.error("Not supported event", event);
      return;
    }
    await dispatch(`${moduleName}/handleEvent`, event, { root: true });

    if (event.card_id) {
      commit("ADD", {
        event: event,
        card: cache.cards.byId(event.card_id)
      });
    }
  },
  emit({ rootState }, event) {
    if (!event.action) {
      console.error("to emit event action must be set!", event);
      return;
    }
    if (utils.isDebug()) {
      console.log("emit: ", event);
    }

    if (event.list) {
      event.list_id = event.list.id;
      delete event.list;
    }
    if (event.card) {
      event.card_id = event.card.id;
      delete event.card;
    }
    if (event.board) {
      event.board_id = event.board.id;
      delete event.board;
    }

    event.user_id = rootState.users.active.id;

    if (!event.board_id && rootState.boards.active) {
      event.board_id = rootState.boards.active.id;
    }

    vue.$socket.emit("event", event);
  },
  getNewEvents({ state }) {
    if (!state.loaded) return;

    vue.$socket.emit("get_new_events", {
      from: state.last ? state.last.id : 1
    });
  }
};

function add(state, card, event) {
  if (!event) return;

  if (!event.id) {
    console.error("Cant add event without id", event);
    return;
  }

  if (!event.card_id)
    //не относится к карточке, так что на м не особо пока интересен
    return;

  if (!card) {
    //console.error('card is not existing for event', event);
    return;
  }

  if (!event.moment) {
    event.moment = moment(event.date);
  }

  if (cache.events.tryAdd(event)) {
    state.all.push(event);
  }

  if (!card.events.find(e => e.id == event.id)) {
    card.events.push(event);
  }

  if (!state.last || state.last.id < event.id) {
    state.last = event;
  }
}

// mutations
const mutations = {
  ADD_RANGE(state, items /* [{ card, event }] */) {
    items.forEach(i => {
      add(state, i.card, i.event);
    });
  },
  ADD(state, { card, event }) {
    add(state, card, event);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
